import api from '@/libs/api'

export default {
  namespaced: true,
  state: {
    fetchingUser: false,
    user: {},
    updatingUser: false,
    noDefaultOrganization: false,
    noDefaultProject: false,
  },
  mutations: {
    SET_USER(state, data) {
      state.user = data

      if (data.defaultOrganizationId === null) {
        state.noDefaultOrganization = true
      } else {
        state.noDefaultOrganization = false
      }

      if (data.defaultProjectId === null) {
        state.noDefaultProject = true
      } else {
        state.noDefaultProject = false
      }
    },
    SET_FETCHING_USER(state, value) {
      state.fetchingUser = value
    },
    SET_UPDATING_USER(state, value) {
      state.updatingUser = value
    },
    SET_NO_DEFAULT_ORGANIZATION(state, value) {
      state.noDefaultOrganization = value
    },
    SET_NO_DEFAULT_PROJECT(state, value) {
      state.noDefaultProject = value
    },
  },
  actions: {
    fetchUser({ commit }) {
      commit('SET_FETCHING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .get('/users', { noSignalNeeded: true })
          .then(response => {
            commit('SET_USER', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_USER', false)
          })
      })
    },
    updateUser({ commit }, user) {
      commit('SET_UPDATING_USER', true)
      return new Promise((resolve, reject) => {
        api('captain')
          .put('/users', user)
          .then(response => {
            commit('SET_USER', response.data.result)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_UPDATING_USER', false)
          })
      })
    },
  },
}
